import axios from 'axios';
import { action, computed, observable } from 'mobx';

import userStore from './stores/UserStore';

class AppState {
	@observable dialogMsg = {
		showing: false,
		title: '',
		message: ''
	}
	dialogCloseCb = false;

	@observable account = {
		account_id: 0,
		account_name: ''
	};
	@observable users = [];

	constructor() {
		if ('startupUser' in window) {
			const startupUser = window['startupUser'];
			userStore.user.user_id = startupUser.user_id;
			userStore.user.user_name = startupUser.user_name;
			userStore.user.email = startupUser.email;
			userStore.user.phone = startupUser.phone;
			userStore.user.role = startupUser.role;
			userStore.user.account_id = startupUser.account_id;
			userStore.user.regions.replace(startupUser.regions);
		}
	}

	@computed get isLoggedIn() {
		return userStore.user.user_id > 0;
	}

	login(formData) {
		return axios.post('/api/login', formData).then((resp) => {
			this.setUser(resp.data);
			return resp.data;
		});
	}

	@action
	logout() {
		userStore.user.user_id = 0;
		userStore.user.user_name = '';
		userStore.user.email = '';
		userStore.user.phone = '';
		userStore.user.role = '';
		userStore.user.account_id = 0;
		userStore.user.regions.clear();
		userStore.user.registration_url = '';
	}

	@action
	setUser(user) {
		userStore.user.user_id = user.user_id;
		userStore.user.user_name = user.user_name;
		userStore.user.email = user.email;
		userStore.user.phone = user.phone;
		userStore.user.role = user.role;
		userStore.user.account_id = user.account_id;
		userStore.user.regions.replace(user.regions);
		userStore.user.registration_url = user.registration_url;
	}

	getUser() {
		return userStore.user;
	}

	getUser_name() {
		return userStore.user.user_name;
	}

	getUser_account() {
		return userStore.user.account_id;
	}

	getUser_registration_url() {
		return userStore.user.registration_url;
	}

	showMessage = action((msg, title, closeCb = false) => {
		this.dialogCloseCb = closeCb;
		this.dialogMsg.message = msg;
		this.dialogMsg.title = title || '';
		this.dialogMsg.showing = true;
	})
}

export default AppState;



/** WEBPACK FOOTER **
 ** ./src/AppState.js
 **/